export const { FormData } = globalThis
